import React, { createContext, useState } from 'react';
import { MandatoryChildren } from '../../../models/children-props';

export type ActiveCustomizeIndexType = number | undefined;
export const ActiveCustomizeIndexContext = createContext<ActiveCustomizeIndexType>(undefined);

export const ActiveCustomizeIndexContextProvider = ({
  children,
  index
}: MandatoryChildren<{ index: ActiveCustomizeIndexType }>): JSX.Element => {
  const [value] = useState(index);

  return <ActiveCustomizeIndexContext.Provider value={value}>{children}</ActiveCustomizeIndexContext.Provider>;
};
